(() => {
  const initMobilePurchase = (root = document) => {
    root.querySelectorAll('[data-bt-mobile-purchase]').forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;

      const targetId = bar.dataset.targetButton;
      const primaryButton = targetId ? document.getElementById(targetId) : null;
      const stickyButton = bar.querySelector('.bt-mobile-purchase__button');
      const stickyLabel = bar.querySelector('[data-bt-mobile-purchase-label]');

      if (!primaryButton || !stickyButton || !stickyLabel) return;

      bar.dataset.initialized = 'true';

      const syncButton = () => {
        const primaryLabel = primaryButton.querySelector('span');
        const label = primaryLabel?.textContent?.trim();

        stickyButton.disabled = primaryButton.disabled || primaryButton.getAttribute('aria-disabled') === 'true';
        if (label) stickyLabel.textContent = label;
      };

      const syncVisibility = () => {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const hasPassedPrimaryButton = primaryButton.getBoundingClientRect().bottom < 0;
        const isVisible = isMobile && hasPassedPrimaryButton;

        bar.classList.toggle('is-visible', isVisible);
        bar.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        stickyButton.tabIndex = isVisible ? 0 : -1;
        document.body.classList.toggle('bt-sticky-purchase-visible', isVisible);
      };

      let frameRequested = false;
      const requestVisibilitySync = () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(() => {
          frameRequested = false;
          syncVisibility();
        });
      };

      stickyButton.addEventListener('click', () => {
        if (!stickyButton.disabled) primaryButton.click();
      });

      new MutationObserver(syncButton).observe(primaryButton, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      window.addEventListener('scroll', requestVisibilitySync, { passive: true });
      window.addEventListener('resize', requestVisibilitySync, { passive: true });
      syncButton();
      syncVisibility();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMobilePurchase());
  } else {
    initMobilePurchase();
  }

  document.addEventListener('shopify:section:load', (event) => initMobilePurchase(event.target));
})();
